module.exports = __webpack_public_path__ + "img/8.0087e2be.jpg";